import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import trTR from 'antd/lib/locale/tr_TR';
import StoreProvider from 'context'; // it will change with redux

import store from './store/index'
import {Provider} from 'react-redux'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <StoreProvider>
  
      <BrowserRouter>  
        <ConfigProvider locale={trTR}>
          <App />
        </ConfigProvider>
      </BrowserRouter>
    </StoreProvider></Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
